<div class="relative">
    <div 
        #trigger
        class="relative w-full border border-gray-300 px-3 py-2 text-sm  rounded-lg
                cursor-pointer flex justify-between items-center"
        style="min-width: fit-content;"
        [ngClass]="{
            'bg-gray-300 bg-opacity-50 text-gray-400': disabled,
             'bg-white': !disabled ,
            'my-theme-custom-select-color-open' : isOpenSelect && !disabled
        }"
        (click)="disabled ? null : toggleDropdown()"
    >
        <span  ngClass="{{!valueIn.name  ? 'text-gray-600' : 'text-black'}}">
            {{valueIn.name || ( placeholder || 'กรุณาเลือกข้อมูล') }}
        </span>
        <svg *ngIf="!disabled" class="w-4 h-4 ml-2 transition-transform" 
            [ngClass]="{ 'rotate-180' : isOpenSelect , 'rotate-0' : !isOpenSelect}"  
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
            >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
    </div>
    <!-- ตัวเลือกประเภท -->
    <div
        class="absoulte w-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-b-lg shadow z-[9999]"
        *ngIf="isOpenSelect"
        [style.top.px]="dropdownTop"
        [style.left.px]="dropdownLeft"
        [style.width.px]="dropdownWidth"
        style="z-index: 999; min-width: fit-content;"
    >
        <div 
            class="px-3 py-1 bg-white cursor-pointer text-gray-400"
            style="font-size: 16px;"
        >
            {{ placeholder }}
        </div>
        <div 
            *ngFor="let item of option; let i = index" 
            class="px-3 bg-white my-theme-custom-select-color cursor-pointer "
            [ngClass]="{
                'my-theme-custom-select-color-active' : item.value === valueIn.value && item.value !== '',
                'bg-gray-300 bg-opacity-50 text-gray-400 text-sm py-0' : item.value === '',
                'py-2' : item.value !== '' || item.value === valueIn.value
            }"
            [class.rounded-b-lg]="i+1 === option.length"
            (click)="item.value !== ''? onClickSelect(item) : null"
        >   

            {{ item.name }}
        </div>
    </div>
</div>